export class UploaderMessages {
  public or = 'uploader.or';
  public search = 'uploader.search';
  public slip = 'uploader.slip';
  public create = 'uploader.upload.create';
  public uploadOriginalFile = 'uploader.upload.original_file';
  public uploadSignedFile = 'uploader.upload.signed_file';
  public uploadUploadCheck = 'uploader.upload.upload_check';
  public uploadUploadReset = 'uploader.upload.upload_reset';
  public uploadUploadFile = 'uploader.upload.upload_file';
  public uploadUploadFileMax = 'uploader.upload.upload_file_max';
  public verifySignUploadText1 = 'uploader.upload.verify_sign_upload_text_1';
  public verifySignUploadText2 = 'uploader.upload.verify_sign_upload_text_2';
  public verifySign = 'uploader.upload.verify_sign';
  public verifySignUChooseFile = 'uploader.upload.verify_sign_choose_file';
  public verifySignContract = 'uploader.upload.verify_sign_contract';
  public verifySignComplementary = 'uploader.upload.verify_sign_complementary';

  constructor() {
  }
}
